import React from 'react';

interface DobleBadgeProps {
  estadoEntrada: 'Reservada' | 'Nominada' | 'Acreditada' | 'Transferida';
  estadoPago: 'PENDIENTE' | 'APROBADO' | 'RECHAZADO' | 'EXPIRADO' | string;
}

export const DobleBadge: React.FC<DobleBadgeProps> = ({ estadoEntrada, estadoPago }) => {
  const getBadgeEntrada = () => {
    switch (estadoEntrada) {
      case 'Acreditada':
        return 'bg-purple-100 text-purple-800 border-purple-300 dark:bg-purple-900/40 dark:text-purple-300 dark:border-purple-700/50';
      case 'Nominada':
        return 'bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-700/50';
      case 'Transferida':
        return 'bg-indigo-100 text-indigo-800 border-indigo-300 dark:bg-indigo-900/40 dark:text-indigo-300 dark:border-indigo-700/50';
      case 'Reservada':
      default:
        return 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700/50';
    }
  };

  const getBadgePago = () => {
    switch (estadoPago.toUpperCase()) {
      case 'APROBADO':
        return 'bg-emerald-500 text-white';
      case 'PENDIENTE':
        return 'bg-amber-500 text-white';
      case 'RECHAZADO':
      case 'EXPIRADO':
        return 'bg-rose-500 text-white';
      default:
        return 'bg-slate-400 text-white';
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
      <span className={`px-2.5 py-1 text-xs font-semibold rounded-full border ${getBadgeEntrada()}`}>
        Entrada: {estadoEntrada}
      </span>
      <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${getBadgePago()}`}>
        Pago: {estadoPago}
      </span>
    </div>
  );
};
